import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

import { QUERY_KEY as DISTANCE_STATUS_QUERY_KEY } from './useDistanceCalculationStatus';
import { QUERY_KEY as SEARCH_HISTORY_QUERY_KEY } from './useGetSearchHistory';

interface TriggerDistanceCalculationResponse {
  success: boolean;
  message: string;
}

export const useTriggerDistanceCalculation = () => {
  const { session } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (searchId: string) => handleApiCall<TriggerDistanceCalculationResponse>(
      session,
      'POST',
      getResolvedEndpoint('vendor/search/:searchId/calculate-distances', { searchId })
    ),
    onSuccess: (_, searchId) => {
      // Invalidate related queries to trigger refetch
      queryClient.invalidateQueries({ queryKey: DISTANCE_STATUS_QUERY_KEY(searchId) });
      queryClient.invalidateQueries({ queryKey: SEARCH_HISTORY_QUERY_KEY() });
      queryClient.invalidateQueries({ 
        queryKey: ['GET', 'vendor/search/:searchId/vendors', { searchId }],
      });
      queryClient.invalidateQueries({ 
        queryKey: ['GET', 'vendor/search/:searchId', { searchId }],
      });
    },
  });
};